import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from '@mui/material';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export function FilterSelect({ label, filter, handleChangeFilter, items, multiple }) {
  function renderValue(selected) {
    return multiple ? selected.join(', ') : selected;
  }

  const emptyVal = (
    <MenuItem key="empty" value="">
      <ListItemText primary="Any" />
    </MenuItem>
  );

  return (
    <>
      <FormControl sx={{ m: 1, width: 300 }} size="small">
        <InputLabel id="filter_label">{label}</InputLabel>
        <Select labelId="filter_label" value={filter} onChange={handleChangeFilter} renderValue={renderValue} multiple={multiple} input={<OutlinedInput label={label} />} MenuProps={MenuProps}>
          {!multiple ? emptyVal : ''}
          {items.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {multiple ? <Checkbox checked={filter.indexOf(item.value) > -1} /> : ''}
              <ListItemText primary={item.value} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
}
